import { User } from "@prisma/client";
import { prisma } from "../../prisma";
import { CreateFastifyContextOptions } from "@trpc/server/adapters/fastify";

export interface Context {
    contextUser: User | null;
    prisma: typeof prisma;
}

export const createTRPCContext = async ({ req }: CreateFastifyContextOptions): Promise<Context> => {
    let contextUser = null;
    const email = req.headers["x-user-email"] as string | undefined;
    if (email) {
        contextUser = await prisma.user.findUnique({
            where: { email },
        });
    }

    return {
        contextUser,
        prisma,
    };
};
